import { mapRange } from '@wix/wow-utils';
import { roundNumber } from '../../utils';
const POWER_TO_JELLO_FACTOR_MAP = {
  soft: 1,
  medium: 2,
  hard: 4
};
const SKEW_Y_KEYFRAMES = [{
  keyframe: 24,
  skewY: 7
}, {
  keyframe: 38,
  skewY: -2
}, {
  keyframe: 58,
  skewY: 4
}, {
  keyframe: 80,
  skewY: -2
}, {
  keyframe: 100,
  skewY: 0
}];
export default function create(options) {
  const {
    power,
    intensity = 0.25
  } = options.namedEffect;
  const duration = options.duration || 0;
  const delay = options.delay || 0;
  const responsiveJelloFactor = mapRange(0, 1, POWER_TO_JELLO_FACTOR_MAP.soft, POWER_TO_JELLO_FACTOR_MAP.hard, intensity);
  const jelloFactor = power && POWER_TO_JELLO_FACTOR_MAP[power] || responsiveJelloFactor;
  const keyframes = SKEW_Y_KEYFRAMES.map(_ref => {
    let {
      keyframe,
      skewY
    } = _ref;
    return {
      offset: keyframe / 100 * (duration / (duration + delay)),
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) skewY(${roundNumber(skewY * jelloFactor)}deg)`
    };
  });
  return [{
    ...options,
    delay: 0,
    easing: 'linear',
    duration: duration + delay,
    keyframes
  }];
  /*
   *
   * @keyframes <name> {
   *   <duration / (duration + delay)> {
   *     transform: rotate(<rotation>deg) skewY(<skewY * jelloFactor>deg);
   *   }
   *   100% {
   *     transform: rotate(<rotation>deg) skewY(0deg);
   *   }
   * }
   *
   *
   * #target {
   *   animation: <name> <duration + delay> 0s linear infinite;
   * }
   */
}
//# sourceMappingURL=Jello.js.map